import React from 'react';
import {
  capitalize,
  capitalizeEachWord,
  formatDate,
} from "../../../Common/CommonFunction";
import github from "../../../../assets/images/resumeIcons/githubwhite.png";
import linkedin from "../../../../assets/images/resumeIcons/linkedinwhite.png";
import emailwhite from "../../../../assets/images/resumeIcons/emailwhite.png";
import callwhite from "../../../../assets/images/resumeIcons/callwhite.png";

import locationwhite from "../../../../assets/images/resumeIcons/locationwhite.png";
import star_blank from "../../../../assets/images/star/star_blank.png"
import star_half from "../../../../assets/images/star/star_half.png"
import star from "../../../../assets/images/star/star.png"
import { educationLevelsOptions, JOBSEEKER_PROFILE_IMAGE, performanceScaleOptions, schoolMediumsOptions } from "../../../../Constant";

const Resume3 = ({ jobseekerData = {} }) => {
  const {
    jobseeker_full_name = "",
    jobseeker_preferred_job_title = "",
    work_experience = [],
    education = [],
    it_skills = [],
    work_sample = [],
    jobseeker_phone1 = "",
    jobseeker_email1 = "",
    country_code1 = "",
    jobseeker_photo = "",
    jobseeker_location = {},
    online_detail_result = [],
    primary_skill = [],
    resume_headline = ""
  } = jobseekerData;

  const renderSocialIcon = (socialProfileName) => {
    switch (socialProfileName.toUpperCase()) {
      case "LINKEDIN":
        return <img style={{ width: "20px" }} className="me-2" src={linkedin} alt="LinkedIn Icon" />;
      case "GITHUB":
        return <img style={{ width: "20px" }} className="me-2" src={github} alt="GitHub Icon" />;
      default:
        return null;
    }
  };

  return (
    <div id="resume3">
      <main className="resume3">
        {/* <header>
          <a href="#" target="_blank"><img

            src="/job/naukrify_poweredby.png"
            // src="https://dev.naukrify.com/job/naukrify_poweredby.png"
            alt="User profile picture"
            className="img-fluid"
          /></a>
        </header> */}
        <div class="header-frame">
          <header>
            <a href="#" target="_blank"><img

              src="/job/naukrify_poweredby.png"
              // src="https://dev.naukrify.com/job/naukrify_poweredby.png"
              alt="User profile picture"
              className="img-fluid"
            /></a>
          </header>
          <div className="profile-header-combo">
            {jobseeker_photo && (
              <div className="profile_img_container">
                <img src={jobseeker_photo} alt="Profile" />
              </div>
            )}
            <div className="name-container">
              <div className="name-prf">
                <div className="full-name">
                  <span className="fname">{jobseeker_full_name}</span>
                </div>
                {jobseeker_preferred_job_title && (
                  <div className="resume-title">{jobseeker_preferred_job_title}</div>
                )}
              </div>
            </div>
          </div>
        </div>
        <div className="container3">
          {/* Left Section */}
          <div className="sidebar">
            <div className="sidebar-info mt-35">
              {/* Contact Section */}
              {(jobseeker_email1 || jobseeker_phone1 || jobseeker_location.label) && (
                <div className="contact mb-20">
                  <div className="section-title">CONTACT</div>
                  <div className="contact-container list-container mt-15">
                    <table>
                      <tbody>
                        {jobseeker_email1 && (
                          <tr className="email">
                            <td><img src={emailwhite} alt="Email" /></td>
                            <td><a href={`mailto:${jobseeker_email1}`}>{jobseeker_email1}</a></td>
                          </tr>
                        )}
                        {jobseeker_phone1 && (
                          <tr className="mobile">
                            <td><img src={callwhite} alt="Phone" /></td>
                            <td><a href={`tel:${country_code1}${jobseeker_phone1}`}>{country_code1}{jobseeker_phone1}</a></td>
                          </tr>
                        )}
                        {jobseeker_location.label && (
                          <tr className="location">
                            <td><img src={locationwhite} alt="Location" /></td>
                            <td>{jobseeker_location.label}</td>
                          </tr>
                        )}
                        {online_detail_result.map((profile, index) => (
                          (profile.social_profile_name.toUpperCase() === "LINKEDIN" ||
                            profile.social_profile_name.toUpperCase() === "GITHUB") && (
                            <tr key={index}>
                              <td>{renderSocialIcon(profile.social_profile_name)}</td>
                              <td>
                                <a href={profile.url} target="_blank" rel="noopener noreferrer">
                                  {profile.url}
                                </a>
                              </td>
                            </tr>
                          )
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}

              {/* Education Section */}
              {education.length > 0 && (
                <div className="education mb-20">
                  <div className="section-title">EDUCATION</div>
                  <div className="list-container mt-15">
                    {education.map((edu, index) => (
                      <div key={index} className="education-item">
                        {edu.education_level != "SECONDARY" &&
                          edu.education_level != "SENIOR_SECONDARY" ? (
                          <div>
                            <p className="degree">
                              {edu.jobseeker_degree &&
                                edu.jobseeker_degree.label}{" "}
                              - {edu.jobseeker_specialization} - {" "}
                              {edu.passing_year}
                            </p>
                            <p>{edu.board}</p>
                            <p>{
                              performanceScaleOptions.find(
                                (option) =>
                                  option.value == edu.performance_scale
                              )?.label
                            }{" "}
                              : {edu.performance}</p>
                          </div>
                        ) : (
                          <div>
                            <p className="degree">
                              {
                                educationLevelsOptions.find(
                                  (option) =>
                                    option.value == edu.education_level
                                )?.label
                              }{" "}
                              - {edu.passing_year}{" "}
                            </p>
                            <p>{edu.board} -{" "}
                              {
                                schoolMediumsOptions.find(
                                  (option) => option.value == edu.school_medium
                                )?.label
                              }
                            </p>
                            <p>{
                              performanceScaleOptions.find(
                                (option) =>
                                  option.value == edu.performance_scale
                              )?.label
                            }{" "}
                              : {edu.performance}</p>
                          </div>
                        )}

                      </div>
                    ))}

                  </div>

                </div>

              )}

              {/* Skills Section */}
              {it_skills.length > 0 && (
                <div className="expertise mb-20">
                  <div className="section-title">Skills</div>
                  <div className="list-container mt-15">
                    <ul className="list">
                      {it_skills.map((skill, index) => (
                        <li className="list-item" key={index}>
                          {skill.it_skill?.label || skill.it_skill || "Skill"}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              )}
            </div>
          </div>

          {/* Right Section */}
          <div className="main-content">
            {resume_headline &&
              <div className="section">
                <div className="section-title mb-10">ABOUT</div>

                <div className="section-content experience-item"><p>{resume_headline}</p></div>

              </div>
            }

            {/* Work Experience Section */}
            {work_experience.length > 0 && (
              <div className="section">
                <div className="section-title mb-10">Experience</div>
                <div className="experience-container">
                  <ul className="experience-list">
                    {work_experience.map((job, index) => (
                      <li key={index}>
                        <div className="section-content experience-item">
                          <h4>{`${capitalizeEachWord(job.designation || "Job Title")} @ ${capitalizeEachWord(job.organization?.label || "Company")}`}</h4>
                          <p>{`${formatDate(job.started_working_from || "Start Date")} - ${formatDate(job.worked_till || "End Date")}`}</p>
                          <p>{job.job_description || "Job Description"}</p>
                        </div>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            )}

            {/* Work Samples Section */}
            {work_sample.length > 0 && (
              <div className="section">
                <div className="section-title mb-10">Work Sample</div>
                <div className="reference-container">
                  {work_sample.map((work, index) => (
                    <div className="section-content" key={index}>
                      <h4>{`${capitalizeEachWord(work.work_title || "Work Title")} (${formatDate(work.work_start || "Start Date")} - ${formatDate(work.work_end || "End Date")})`}</h4>
                      <p className="mb-1"><a href={work.work_url || "#"}>{work.work_url || "Sample URL"}</a></p>
                      <p className="mb-1">{capitalize(work.work_description || "Work Description")}</p>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {/* Main Skills Section */}
            {primary_skill.length > 0 && (
              <div className="section">
                <div className="section-title mb-10">Main Skills</div>
                <div className="skill-list">
                  {primary_skill.map((skill) => (
                    <div key={skill.id} className="main-skill">
                      <p>{skill.label || "Skill Name"}</p>
                      <div className="stars">
                        {[...Array(5)].map((_, i) => {
                          let starImage;
                          if (i < Math.floor(skill.skill_rating / 2)) {
                            starImage = star; // Full star
                          } else if (i < Math.ceil(skill.skill_rating / 2)) {
                            starImage = star_half; // Half star
                          } else {
                            starImage = star_blank; // Empty star
                          }
                          return (
                            <img
                              key={i}
                              className="image"
                              src={starImage}
                              alt="star"

                            />
                          );
                        })}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
        </div>
      </main>
    </div>
  );
};

export default Resume3;